import AppHeader, { AppWrapper } from "../../components/AppView";
import AppBody from "../AppBody";
import { LOCKEDSWAP_ADDRESS,TOKEN_ADDRESS,LOCKED_ADDRESS } from "../../constants/address";
import { useCallback, useEffect, useMemo, useState } from "react";
import NumericalInput from "../../components/NumericalInput";
import AddressInput from "../../components/AddressInput";

import Row from "../../components/Row";
import { ButtonPrimary } from "../../components/Button";

import { AutoColumn } from "../../components/Column";
import styled, { useTheme } from "styled-components";

import { Trans } from "@lingui/macro";

import useSimpleSwapLocked from "../../hooks/useSimpleSwapLocked";

import Loader from "../../components/Loader";
import { fromAmount, toAmount } from "../../utils/amount";

import { useWallet } from "use-wallet";
import useERC20Allowance from "../../hooks/useERC20Allowance";
import useERC20Approve from "../../hooks/useERC20Approve";
import useERC20Balance from "../../hooks/useERC20Balance";
import useToken from "../../hooks/useToken";
import Big from "big.js";
import { ZERO_ADDRESS } from "../../utils/ethereum";
import Modal from "../../components/Modal";
import { LoadingView, SubmittedView } from "../../components/ModalViews";
import PromoteBanner from "../../components/PromoteBanner";

const LabelWrapper = styled.div`
  font-size: 14px;
`;
const InputAddress = styled(AddressInput)`
  width: 100%;
  border-radius: 24px;
  padding: 8px 12px;
`;

const InputText = styled(NumericalInput)`
  width: 100%;
  border-radius: 24px;
  padding: 8px 12px;
`;
const Symbol = styled.div`
  margin-left: 8px;
`;

const BalanceWrapper = styled.div`
  padding: 4px 2px;
  font-size: 14px;
`;

const ItemActionWrapper = styled.div`
  display: flex;
  margin-top: 12px;

  & > * {
    flex: 1;
    margin-right: 8px;
  }

  & > *:last-child {
    margin-right: unset;
  }
`;

function SwapLockConsole() {
  const {
    chainId,
    account,
    // balance,
  } = useWallet();
  // const theme = useTheme();
  const {
    swapContract,
    getLockedAddr,
    getTokeAddr,
    // USDT_ADDRESS,
    // TOKEN_ADDRESS,
    // LOCKED_ADDRESS,
    //LOCKED_ADDRESS,
    getTokenPrice,
    setLockedParam,
    getLockedParam,
    setLockedAddr,
    setMinAmount,
    getminamount,
    setTokenPrices,
    getFromTokens,
    getToTokens,
    swapToken,
    getpledgedays,
    getgapdays,
    getstartprenum,
    getSwapValue,
  } = useSimpleSwapLocked(LOCKEDSWAP_ADDRESS[chainId]);

  const [token] = useToken(TOKEN_ADDRESS[chainId]);
  const tokenContract = useMemo(() => {
    if (token) {
      return token.contract;
    }
    return null;
  }, [token]);

  const tokenBalance = useERC20Balance(tokenContract, account);
  const [allowance, fetchAllowance] = useERC20Allowance(
    tokenContract,
    account,
    LOCKEDSWAP_ADDRESS[chainId]
  );

  const [onApprove, approveLoading] = useERC20Approve(
    tokenContract,
    LOCKEDSWAP_ADDRESS[chainId]
  );

  //const [inputValue, setInputValue] = useState('');
  //const [value, setValue] = useState("");
   const [lockAddress, setLockAddress] = useState("");
  // const [outputValueEnough, setOutputValueEnough] = useState(true);

  // const [loading, setLoading] = useState(false);
  // const [isSubmitShow, setIsSubmitShow] = useState(false);
  // const [submitHash, setSubmitHash] = useState("");
  // const [submitError, setSubmitError] = useState("");

  const [pledgedays, setPledgedays] = useState(540);
  const [gapdays, setGapdays] = useState(1);
  const [startprenum, setStartprenum] = useState(0);

  const [minamount, setMinamount] = useState("");

  const [tokenaddr, setTokenaddr] = useState("");
  const [tokenprice, setTokenprice] = useState("");
  const [tokename, setTokename] = useState("PRT");

  const [lockedParamloading, setLockedParamloading] = useState(false); // 存款
  const [minAmountloading, setMinAmountloading] = useState(false); // 提现

  const [tokenPricesloading, setTokenPricesloading] = useState(false); // 提现


    // 获取输出列表
    useEffect(() => {
      const fetch = async () => {
        try {
          const info={};
          info.params= await getLockedParam();
          setPledgedays(info.params[0]);
          setGapdays(info.params[1]);
          setStartprenum(info.params[2]);
          info.minamount= await getminamount();
          setMinamount(info.minamount)

          info.lockAddr= await getLockedAddr();
          info.tokendAddr= await getTokeAddr();

          setTokenaddr(info.tokendAddr);
          info.tokenprice= await getTokenPrice(info.tokendAddr);
          setTokenprice(info.tokenprice);
        } catch (e) {
          console.log(e);
        }
      };
  
      if (swapContract) {
        fetch();
      }
      return () => {};
    }, [swapContract,getToTokens,getLockedAddr,getTokeAddr,getLockedParam,getminamount]);
  
  
  // 变更锁仓参数
  const handlesetLockedParam = useCallback(async () => {
    const tx = await setLockedParam(
      pledgedays,
      gapdays,
      startprenum,
      setLockedParamloading
    );

  }, [pledgedays, gapdays, startprenum, setLockedParam]);

  // 变更最少购买数量
  const handlesetMinAmount = useCallback(async () => {
    const tx = await setMinAmount(minamount, setMinAmountloading);

  }, [minamount, setMinAmount]);

  // 变更交换token价格
  const handlesetTokenPrices = useCallback(async () => {
    const tx = await setTokenPrices(
      tokenaddr,
      tokenprice,
      tokename,
      setTokenPricesloading
    );
  }, [tokenaddr, tokenprice, tokename, setTokenPrices]);

  return (
    <>
      <AppBody>
        <AppHeader>
          <Trans>Set Locked Tokens</Trans>
        </AppHeader>
        <AppWrapper>
          <AutoColumn gap={"sm"}>
            <AutoColumn gap={"2px"}>
              <AutoColumn gap={"sm"}>
                <LabelWrapper>
                  <Trans>Min Swap Amount</Trans>
                </LabelWrapper>
                <Row>
                  <InputText value={minamount} onUserInput={setMinamount} />
                  <Symbol>{"PRT"}</Symbol>
                </Row>
              </AutoColumn>

              <AutoColumn gap={"sm"}>
                <ButtonPrimary
                 disabled={ minAmountloading } 
                onClick={handlesetMinAmount}>Update MinAmount{ minAmountloading ? <Loader /> : null }</ButtonPrimary>
              </AutoColumn>

              <AutoColumn gap={"sm"}>
                <LabelWrapper>
                  <Trans>Locked Days</Trans>
                </LabelWrapper>
                <Row>
                  <InputAddress
                    value={pledgedays}
                    onUserInput={setPledgedays}
                  />
                </Row>
              </AutoColumn>

              <AutoColumn gap={"sm"}>
                <LabelWrapper>
                  <Trans>Release Interval Days</Trans>
                </LabelWrapper>
                <Row>
                  <InputAddress value={gapdays} onUserInput={setGapdays} />
                </Row>
              </AutoColumn>

              <AutoColumn gap={"sm"}>
                <LabelWrapper>
                  <Trans>initial release Ratio(%)</Trans>
                </LabelWrapper>
                <Row>
                  <InputAddress
                    value={startprenum}
                    onUserInput={setStartprenum}
                  />
                </Row>
              </AutoColumn>

              <AutoColumn gap={"sm"}>
                <ButtonPrimary
                 disabled={ lockedParamloading } 
                 onClick={handlesetLockedParam}>Update LockedParam{ lockedParamloading ? <Loader /> : null }</ButtonPrimary>
              </AutoColumn>


              
              <AutoColumn gap={"sm"}>
                <LabelWrapper>
                  <Trans>tokenaddr</Trans>
                </LabelWrapper>
                <Row>
                  <InputAddress
                    value={tokenaddr}
                    onUserInput={setTokenaddr}
                  />
                </Row>
              </AutoColumn>

              <AutoColumn gap={"sm"}>
                <LabelWrapper>
                  <Trans>tokenprice</Trans>
                </LabelWrapper>
                <Row>
                  <InputText value={tokenprice} onUserInput={setTokenprice} />
                </Row>
              </AutoColumn>

              <AutoColumn gap={"sm"}>
                <LabelWrapper>
                  <Trans>tokename</Trans>
                </LabelWrapper>
                <Row>
                  <InputAddress
                    placeholder=" "
                    value={tokename}
                    onUserInput={setTokename}
                  />
                </Row>
              </AutoColumn>

              <AutoColumn gap={"sm"}>
                <ButtonPrimary
                disabled={ tokenPricesloading } 
                onClick={handlesetTokenPrices}>Update Tokenprice  { tokenPricesloading ? <Loader /> : null }</ButtonPrimary>
              </AutoColumn>
            </AutoColumn>
          </AutoColumn>
        </AppWrapper>
      </AppBody>
    </>
  );
}

export default SwapLockConsole;
